module.exports = __webpack_public_path__ + "img/error.a26da730.webp";